module.exports = __webpack_public_path__ + "img/arrow-left.a80ff2b3.svg";